import { toast } from "react-toastify";
import { Style } from "cpl-react-common/Helpers/AlertHelpers";
import { setMessage, setShowMessage, setStyle } from "./SignalRAlertSlice";
import { setCPLMaintenanceDates } from "app/system/maintenance/MaintenanceSlice";
import { setPercentage } from "./SignalRProgressBarSlice";
import { IMaintenanceService } from "services/MaintenanceService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

/* eslint-disable @typescript-eslint/no-explicit-any */

export const displayToastMessage = (message: string, style: Style) => {
  switch (style) {
    case Style.Danger:
      toast.error(message);
      break;
    case Style.Info:
      toast.info(message);
      break;
    case Style.Success:
      toast.success(message);
      break;
    case Style.Warning:
      toast.warning(message);
      break;
  }
};

export const displayAlert = (dispatch: (arg0: any) => any, message: string, style: Style) => {
  dispatch(setMessage(message));
  dispatch(setStyle(style));
  dispatch(setShowMessage(true));
};

export const setupCommonSignalRFunctions = (connection: signalR.HubConnection, dispatch: (arg0: any) => any) => {
  connection.on("SendCPLMaintenanceDates", (dates) => {
    const maintenanceService = container.get<IMaintenanceService>(SERVICE_TYPES.CPLAuthMaintenanceClient);
    const convertedDates = maintenanceService.convertMaintenanceDates(dates);
    dispatch(setCPLMaintenanceDates(convertedDates));
  });
  connection.on("UpdateProgress", (percentage) => dispatch(setPercentage(percentage)));

  connection.on("SendSuccessAlert", (notification) => displayAlert(dispatch, notification, Style.Success));
  connection.on("SendWarningAlert", (notification) => displayAlert(dispatch, notification, Style.Warning));
  connection.on("SendInfoAlert", (notification) => displayAlert(dispatch, notification, Style.Info));
  connection.on("SendDangerAlert", (notification) => displayAlert(dispatch, notification, Style.Danger));
  connection.on("SendSuccessToast", (notification) => displayToastMessage(notification, Style.Success));
  connection.on("SendWarningToast", (notification) => displayToastMessage(notification, Style.Warning));
  connection.on("SendInfoToast", (notification) => displayToastMessage(notification, Style.Info));
  connection.on("SendDangerToast", (notification) => displayToastMessage(notification, Style.Danger));
};
